module.exports = __webpack_public_path__ + "static/power-img2-2@2x-2817ddbed5350466e566d4428f4b39d5.png";